export const ROLES = {
  SSDI_SUPER_ADMIN: "SSDI_SUPER_ADMIN",
  REPO_ADMIN: "REPO_ADMIN",
  TEAM_LEADER: "TEAM_LEADER",
  HEAD_OFFICE_STAFF: "HEAD_OFFICE_STAFF",
  OFFICE_STAFF: "OFFICE_STAFF",
  REPO_STAFF: "REPO_STAFF",
  REPO_VIEWER: "REPO_VIEWER",
};

export const isSsdiAdmin = (role) => role === ROLES.SSDI_SUPER_ADMIN;

export const isRepoAdmin = (role) => role === ROLES.REPO_ADMIN;

export const isRepoAgent = (role) =>
  [
    ROLES.TEAM_LEADER,
    ROLES.HEAD_OFFICE_STAFF,
    ROLES.OFFICE_STAFF,
    ROLES.REPO_STAFF,
    ROLES.REPO_VIEWER,
  ].includes(role);

export const isRepoUser = (role) =>
  [
    ROLES.REPO_ADMIN,
    ROLES.TEAM_LEADER,
    ROLES.HEAD_OFFICE_STAFF,
    ROLES.OFFICE_STAFF,
    ROLES.REPO_STAFF,
    ROLES.REPO_VIEWER,
  ].includes(role);

export const PATH_TO_PERMISSION = {
  "/home": "home.view",
  "/profile": "profile.view",
  "/id-card": "id_card.view",
  "/plans": "plans.view",
  "/control-panel": "control_panel.view",
  "/cases": "cases.view",
  "/find-vehicles": "find_vehicles.view",
  "/vehicle-trace": "find_vehicles.view",
  "/confirmation": "confirmation.view",
  "/inventory-update": "inventory_update.view",
  "/field-map": "field_map.view",
  "/live-tracking": "live_tracking.view",
  "/reports": "reports.view",
  "/users": "users.view",
  "/email-configuration": "email_config.manage",
  "/bank-details": "upload_records.view",
  "/bank-records": "bank_records.view",
  "/code-bank-nbfc": "code_bank_nbfc.view",
  "/otps": "otps.view",
  "/blacklist": "blacklist.view",
  "/feedback": "feedback.view",
  "/clean-file": "clean_file.view",
};